// @flow

import { CONFERENCE_JOINED } from '../../../../react/features/base/conference/actionTypes';
import {
    DOMINANT_SPEAKER_CHANGED,
    PARTICIPANT_JOINED,
    PARTICIPANT_LEFT,
    PIN_PARTICIPANT
} from '../../../../react/features/base/participants/actionTypes';
import { getLocalParticipant } from '../../../../react/features/base/participants/functions';
import MiddlewareRegistry from '../../../../react/features/base/redux/MiddlewareRegistry';
import {
    TRACK_ADDED,
    TRACK_REMOVED,
    TRACK_UPDATED
} from '../../../../react/features/base/tracks/actionTypes';
import { getTrackByJitsiTrack } from '../../../../react/features/base/tracks/functions';
import { TOGGLE_PIN_STAGE_PARTICIPANT } from '../../../../react/features/filmstrip/actionTypes';

import {
    wizyActiveSpeakerAdded,
    wizyActiveSpeakerRemoved,
    wizyRemoveParticipantFromLargeVideo,
    wizySelectParticipant, wizySelectParticipantInLargeVideo
} from './actions';

import './subscriber';

/**
 * Middleware that catches actions related to participants and tracks and
 * dispatches an action to select a participant depicted by LargeVideo.
 *
 * @param {Store} store - Redux store.
 * @returns {Function}
 */
MiddlewareRegistry.register(store => next => action => {
    const result = next(action);

    if (!APP.wildix.wizy) {
        return result;
    }

    switch (action.type) {
    case DOMINANT_SPEAKER_CHANGED: {
        const localParticipant = getLocalParticipant(store.getState());

        if (localParticipant && localParticipant.id !== action.participant.id) {
            store.dispatch(wizyActiveSpeakerAdded(action.participant.id));
            store.dispatch(wizySelectParticipantInLargeVideo());
        }

        break;
    }
    case PIN_PARTICIPANT: {
        store.dispatch(wizySelectParticipantInLargeVideo(action.participant?.id));

        return result;
    }
    case PARTICIPANT_JOINED:
    case TOGGLE_PIN_STAGE_PARTICIPANT:
    case TRACK_ADDED:
    case TRACK_REMOVED:
        store.dispatch(wizySelectParticipantInLargeVideo());
        break;

    case PARTICIPANT_LEFT:
        store.dispatch(wizyActiveSpeakerRemoved(action.participant.id));
        store.dispatch(wizyRemoveParticipantFromLargeVideo(action.participant.id));
        break;

    case CONFERENCE_JOINED:
        store.dispatch(wizySelectParticipant());
        break;

    case TRACK_UPDATED:
        if ('videoType' in action.track) {
            const state = store.getState();
            const track
                = getTrackByJitsiTrack(
                    state['features/base/tracks'],
                    action.track.jitsiTrack);
            const participantIds = state['wizyconf/large-video'].participantIds;

            participantIds.includes(track.participantId)
                && store.dispatch(wizySelectParticipant());
        }
        break;
    }

    return result;
});
